import { useId } from "react";
import { Campo } from "../ui";

export interface DadosDoCampo {
  id: string;
  rotulo: string;
  tipo: "texto" | "numero" | "data" | "lista" | "multipla" | "sim_nao";
  opcoes: readonly string[];
  obrigatorio: boolean;
}

interface Props {
  campo: DadosDoCampo;
  valor: unknown;
  aoMudar: (valor: unknown) => void;
}

/** O controle certo para cada tipo de campo personalizado. `null` = não preenchido. */
export function EntradaDeCampo({ campo, valor, aoMudar }: Props) {
  const id = useId();
  const obrigatorio = campo.obrigatorio;

  if (campo.tipo === "texto" || campo.tipo === "data") {
    return (
      <Campo
        rotulo={campo.rotulo}
        type={campo.tipo === "data" ? "date" : "text"}
        value={typeof valor === "string" ? valor : ""}
        onChange={(evento) => aoMudar(evento.target.value === "" ? null : evento.target.value)}
        obrigatorio={obrigatorio}
        maxLength={campo.tipo === "texto" ? 2000 : undefined}
      />
    );
  }
  if (campo.tipo === "numero") {
    return (
      <Campo
        rotulo={campo.rotulo}
        type="number"
        step="any"
        value={typeof valor === "number" ? String(valor) : ""}
        onChange={(evento) => {
          const texto = evento.target.value;
          aoMudar(texto === "" || Number.isNaN(Number(texto)) ? null : Number(texto));
        }}
        obrigatorio={obrigatorio}
      />
    );
  }
  if (campo.tipo === "lista" || campo.tipo === "sim_nao") {
    const opcoes =
      campo.tipo === "sim_nao"
        ? [
            { valor: "sim", rotulo: "Sim" },
            { valor: "nao", rotulo: "Não" },
          ]
        : campo.opcoes.map((opcao) => ({ valor: opcao, rotulo: opcao }));
    const atual = campo.tipo === "sim_nao" ? (valor === true ? "sim" : valor === false ? "nao" : "") : typeof valor === "string" ? valor : "";
    return (
      <div className="campo">
        <label className="campo__rotulo" htmlFor={id}>
          {campo.rotulo}
          {obrigatorio ? <span className="campo__obrigatorio" aria-hidden="true">*</span> : null}
        </label>
        <select
          id={id}
          className="campo__controle"
          value={atual}
          onChange={(evento) => {
            const escolhido = evento.target.value;
            if (escolhido === "") aoMudar(null);
            else aoMudar(campo.tipo === "sim_nao" ? escolhido === "sim" : escolhido);
          }}
        >
          <option value="">{obrigatorio ? "Escolha…" : "Não informado"}</option>
          {opcoes.map((opcao) => (
            <option value={opcao.valor} key={opcao.valor}>{opcao.rotulo}</option>
          ))}
        </select>
      </div>
    );
  }
  const marcadas = Array.isArray(valor) ? (valor as string[]) : [];
  return (
    <fieldset className="campo">
      <legend className="campo__rotulo">
        {campo.rotulo}
        {obrigatorio ? <span className="campo__obrigatorio" aria-hidden="true">*</span> : null}
      </legend>
      {campo.opcoes.map((opcao) => (
        <label className="flex items-center gap-2" key={opcao}>
          <input
            type="checkbox"
            checked={marcadas.includes(opcao)}
            onChange={(evento) => {
              const novas = evento.target.checked ? [...marcadas, opcao] : marcadas.filter((item) => item !== opcao);
              aoMudar(novas.length === 0 ? null : novas);
            }}
          />
          <span>{opcao}</span>
        </label>
      ))}
    </fieldset>
  );
}
